<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
        <div class="col-xl-12 col-sm-12 box-col-12">
          <div class="card bg-primary">
            <div class="card-body">
              <div class="media faq-widgets">
                <div class="media-body">
                  <h2>{{this.currentLanguage ==='en'?'About us':'เกี่ยวกับเรา'}}</h2>
                  
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{{this.currentLanguage ==='en'?'RUNRACE – An online race registration system — Affordable, fully equipped with all the necessary features, all in one place. Ready to use within 1 day.':'RUNRACE ระบบรับสมัครงานวิ่งออนไลน์ — ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว พร้อมใช้งานภายใน 1 วัน'}}</b></p>

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{this.currentLanguage ==='en'?'We provide an online race registration system designed to meet the needs of event organizers of all sizes. Our platform offers great value with comprehensive features all in one place. It supports both free registration and standard paid registration. Our system is flexible, user-friendly, and comes with tools that help streamline event management — including participant registration, payment processing, reporting, and other essential functions. With a simple onboarding process, you can launch your registration system within just one day, backed by support from our professional team throughout your journey.':'เราให้บริการระบบรับสมัครงานวิ่งที่ออกแบบมาเพื่อตอบโจทย์ผู้จัดงานทุกขนาด ด้วยค่าใช้จ่ายที่คุ้มค่าและฟังก์ชันการใช้งานครบถ้วนในที่เดียว รองรับทั้งการรับสมัครแบบไม่เสียค่าใช้จ่าย (Free Registration) และการรับสมัครทั่วไป (Standard Registration) ระบบของเรามีความยืดหยุ่น ใช้งานง่าย พร้อมด้วยเครื่องมือที่ช่วยให้การจัดการงานเป็นไปอย่างมีประสิทธิภาพ ไม่ว่าจะเป็นระบบลงทะเบียนผู้สมัคร ระบบชำระเงิน รายงานสรุปผล และฟังก์ชันอื่นๆ ที่เกี่ยวข้อง ด้วยกระบวนการเริ่มต้นที่ไม่ซับซ้อน ท่านสามารถเปิดระบบรับสมัครได้ภายในเวลาเพียง 1 วัน พร้อมรับการสนับสนุนจากทีมงานมืออาชีพตลอดการใช้งาน'}}<br><br>
&nbsp;&nbsp;&nbsp;&nbsp;📞 {{this.currentLanguage ==='en'?'If you are interested or would like more information, please feel free to contact our team anytime.':'หากท่านสนใจหรือต้องการข้อมูลเพิ่มเติม กรุณาติดต่อทีมงานของเราได้ทันที'}}
                </div>
                <vue-feather type="award"></vue-feather>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-5 col-sm-12 box-col-12">
          <div class="card bg-primary">
            <div class="card-body">
              <div class="media faq-widgets">
                <div class="media-body">
                  <h2>{{this.currentLanguage ==='en'?'Contact us':'ติดต่อเรา'}}</h2>
                  <p>Line Official: <a style="color: aliceblue;text-decoration: underline;" target="_blank" href="https://lin.ee/lXoC4App">@892llvwo</a><br>
                    Facebook: <a style="color: aliceblue;text-decoration: underline;" target="_blank" href="https://facebook.com/runrace.in.th">https://facebook.com/runrace.in.th</a><br>
                    E-mail: info@runrace.in.th<br>
                    Tell: 090-494-เก้า98เก้า<br>
                  </p>
                </div>
                <vue-feather type="mail"></vue-feather>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-7 box-col-12">
          <div class="card">
            <div class="card-body">
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 440px"
                  src="../../assets/images/logo/logo.png"
                />
              </div>
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'

export default {

  setup() {
    useHead({
      title: computed(() => `เกี่ยวกับเรา-ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH`),
      meta: [
        {
          name: `description`,
          content: computed(() => `ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH`),
        },
        {
          name: `keywords`,
          content: computed(() => `เกี่ยวกับเรา,ระบบรับสมัครงานวิ่ง,ค้นหารูปวิ่ง, หารูปวิ่ง,งานวิ่ง,runrace,runninghub`),
        }
        ],
     
    })
  },
   data() {
    return {
      currentLanguage: 'th',
    };
  },
  async mounted() {
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
  }


};
</script>